import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list Product-------
const getAllSubCategory = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.subCategory.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllSubCategoryQuery = (filter) => {
    return useQuery(['SubCategory',filter], () => getAllSubCategory(filter));

};
// ------------------ Add Product-------
const addSubCategory = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.subCategory.add, payload);
};
const AddSubCategoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addSubCategory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('SubCategory');
            toastMessage('success', 'Category Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Delete Sub Category-------
const deleteSubCategory = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.subCategory.delete + id);
};
const DeleteSubCategoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteSubCategory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('SubCategory');
            toastMessage('success', 'Sub Cateogry Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Update Sub Category-------
const updateSubCategory = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.subCategory.update + id, payload);
};
const UpdateSubCategoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateSubCategory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('SubCategory');
            toastMessage('success', 'Sub Category Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllSubCategoryQuery, AddSubCategoryMutation, DeleteSubCategoryMutation, UpdateSubCategoryMutation };
